import { createAction, props } from '@ngrx/store';

export const loadNewOrderSelect = createAction(
  '[New Order Select] Load',
  props<{ option: string; params: string; tenantCode?: string; key: string }>(),
);

export const loadNewOrderSelectSuccess = createAction(
  '[New Order Select] Load Success',
  props<{ key: string; data: any[] }>(),
);

export const loadNewOrderSelectFailure = createAction(
  '[New Order Select] Load Failure',
  props<{ key: string; error: string }>(),
);

export const clearNewOrderSelectByKey = createAction('[New Order Select] Clear By Key', props<{ key: string }>());
